import ManagerDto from "../interfaces/ManagerDto";
import { UserDto, FullUserDto } from "../interfaces/UserInterfaces";

interface LoginRequestOptions {
  User_Email: string; 
  User_Password: string;
}

interface ManagerLoginRequestOptions {
  Manager_Username: string; 
  Manager_Password: string;
}

export type FullUserOrUnauthorizedType = FullUserDto | {"error":"Unauthorized"};
export type ManagerOrUnauthorizedType = ManagerDto | {"error":"Unauthorized"};

class AuthApi {
  static async managerLogin(options: ManagerLoginRequestOptions): Promise<ManagerDto> {
    const prom = new Promise<ManagerDto>(async (resolve, reject) => {
      const response = await fetch((process.env.API_HOST||'') + '/api/v1/manager-login', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies in the request
        body: JSON.stringify({ Manager_Username: options.Manager_Username, Manager_Password: options.Manager_Password }),
      });
      if (response.ok) {
        const manager: ManagerDto = await response.json();
        window.localStorage.setItem('manager', JSON.stringify(manager));
        resolve(manager);
      } else {
        reject(new Error('Login failed'));
      }
    });
    return prom;
  }
  
  static async login(options: LoginRequestOptions): Promise<UserDto> {
    const response = await fetch((process.env.API_HOST||'') + '/api/v1/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include', // Include cookies in the request
      body: JSON.stringify({ User_Email: options.User_Email, User_Password: options.User_Password }),
    });
    
    if (response.ok) {
      const user: UserDto = await response.json();
      window.localStorage.setItem('user', JSON.stringify(user));
      return user;
    }
    
    if (response.status === 403) {
      const errorData = await response.json();
      if (errorData.error === 'EMAIL_NOT_VERIFIED') {
        const error = new Error('Email not verified') as any;
        error.code = 'EMAIL_NOT_VERIFIED';
        error.userEmail = errorData.userEmail;
        throw error;
      }
    }
    
    throw new Error('Login failed');
  }

  static async logout(): Promise<void> {
    const prom = new Promise<void>(async (resolve, reject) => {
      const response = await fetch((process.env.API_HOST||'') + '/api/v1/logout', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies in the request
      });
      if (response.ok) {
        window.localStorage.removeItem('user');
        window.localStorage.removeItem('manager');
        resolve();
      } else {
        reject(new Error('Logout failed'));
      }
    });
    return prom;
  }

  static async me(): Promise<FullUserOrUnauthorizedType> {
    const prom = new Promise<FullUserOrUnauthorizedType>(async (resolve, reject) => {
      const response = await fetch((process.env.API_HOST||'') + '/api/v1/me', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies in the request
      });
      if (response.ok || response.status === 401) {
        const user: FullUserOrUnauthorizedType = await response.json();
        resolve(user);
      } else {
        reject(new Error('Failed to fetch user info'));
      }
    });
    return prom;
  }

  static async managerMe(): Promise<ManagerOrUnauthorizedType> {
    const prom = new Promise<ManagerOrUnauthorizedType>(async (resolve, reject) => {
      const response = await fetch((process.env.API_HOST||'') + '/api/v1/manager/me', {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
        credentials: 'include', // Include cookies in the request
      });
      if (response.ok || response.status === 401) {
        const manager: ManagerOrUnauthorizedType = await response.json();
        resolve(manager);
      } else {
        reject(new Error('Failed to fetch manager info'));
      }
    });
    return prom;
  }
}
export default AuthApi;